import {
    useTheme,
  } from "@mui/material";
  import React, { useEffect, useState } from "react";
  import { useDispatch, useSelector } from "react-redux";
  import {
    setExtraProductData,
    setLanguageID,
    setLanguageWords,
    updateDefaultLanguage,
    updateEventDates,
    updateEventOrStdTicketTypesData,
    updateEventsOrStandardTickets,
    updateSelectedDate,
    updateStdDates,
  } from "../store/slice/Ticketing.slice";
  import { useLocation, useNavigate } from "react-router-dom";
  import {
    FetchWidgetConfigDetails,
    GetGuestDetailsByKey,
    getExtraProductDetails,
    getLanguageDetails,
    getWidgetSettings,
    getWidgetTitleandInfo,
  } from "../api/HorecaWidget.service";
  import {
    setLanguageLoaded,
    updateButtonText,
    updateCombinationLang,
    updateGuestInfo,
    updateLanguageData,
    updateWidgetConfig,
    updateWidgetSetting,
  } from "../store/slice/widgetSetting.slice";
  import customParseFormat from "dayjs/plugin/customParseFormat";
  import dayjs from "dayjs";
  import { setCombinationList } from "../store/slice/Activity.slice";
  import { getCombinationList } from "../api/activity.service";
  import {
    fetchEventOrStandardTicketsTypes,
    fetchEventTicketsDates,
    fetchStandardTicketsDates,
    getEventsOrStandardTickets,
  } from "../api/ticketing.service";
  dayjs?.extend(customParseFormat); // Extend for custom date format parsing
  
  let loadSettings = null;
  let widgetIdSettings = null;

const useTicketingWidget = () => {
    const [widgetLoading, setWidgetLoading] = useState(false);
    const [langLoading, setLangLoading] = useState(false);
    const theme = useTheme();
    const {
      totalCount,
      EventDates,
      selectedDate,
      reservType,
      adult,
      child,
      kid,
      baby,
      toddler,
      isBackToHoreca,
      defaultLanguage,
      isOpenWidget,
      SelectedEventOrStdResType
    } = useSelector((store) => store.Ticketing);
    const {
      key,
      widgetConfig,
      languageLoaded,
      guestId,
      resType,
      widgetSetupId,
      buttonText,
      floating
    } = useSelector((store) => store?.widgetSettings);
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [openWidget, setOpenWidget] = useState(
      location?.state?.openWidgetScreen ?? isOpenWidget
    );
    const getWidgetPositionStyle = (position, btn) => {
      switch (position) {
        case "Top":
          return { top: "0", left: "0", transform: "translate(0, 0)" };
        case "Top-Left":
          return { top: "20px", left: "0px", transform: "translate(0, 0)" };
        case "Top-Middle":
          return { top: "0", left: "50%", transform: "translateX(-50%)" };
        case "Top-Right":
          return { top: "0", right: "20px", transform: "translate(0, 0)" };
        case "Middle-Left":
          return { top: "50%", left: "0px", transform: "translateY(-50%)" };
        case "Middle-Center":
          return { top: "50%", left: "50%", transform: "translate(-50%, -50%)" };
        case "Middle-Right":
          return { top: "50%", right: "20px", transform: "translateY(-50%)" };
        case "Bottom-Left":
          return { bottom: "20px", left: "0px", transform: "translate(0, 0)" };
        case "Bottom-Middle":
          return { bottom: "20px", left: "50%", transform: "translateX(-50%)" };
        case "Bottom-Right":
          return { bottom: "0", right: "0", transform: "translate(0, 0)" };
        default:
          if (btn) {
            return { bottom: "0", right: "0", transform: "translate(0, 0)" };
          } else {
            return {
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
            };
          }
      }
    };
    const fetchLanguageDetails = async () => {
      setLangLoading(true);
      try {
        const response = await getLanguageDetails(key);
        if (response?.status != 200) {
          console.error("Error fetching language details widget:", response);
          return;
        }
        dispatch(updateLanguageData(response?.data));
        const langParam = queryParams.get("lang");
        if (response?.data) {
          const defaultLang =
            !defaultLanguage && !langParam
              ? response?.data?.find((item) => item?.defaultLanguage)?.langcode
              : langParam
              ? langParam
              : defaultLanguage;
              localStorage.setItem(
                "widget",
                JSON.stringify({
                  id: widgetSetupId,
                  key: key,
                  lang: defaultLang,
                  resType:resType
                })
              );
  
          dispatch(updateDefaultLanguage(defaultLang));
          dispatch(setLanguageLoaded(true)); // Set the flag to true
          dispatch(setLanguageID(defaultLang?.idlanguage));
        }
        setLangLoading(false);
      } catch (error) {
        console.error("Error fetching language details widget:", error?.message);
        setLangLoading(false);
      }
    };
    const fetchWidgetSettings = async (language) => {
      try {
        const response = await getWidgetSettings(language, key);
        if (response?.status !== 200 || !response?.data) {
          throw new Error(
            "Failed to fetch widget settings. Please try again later."
          );
        }
        loadSettings = response?.data;
        dispatch(updateWidgetSetting(response?.data));
      } catch (error) {
        const errorMsg =
          error?.message ||
          "An unexpected error occurred while fetching widget settings.";
        console.error("Error fetching widget settings:", errorMsg);
      }
    };
    const fetchWidgetTitleandInfo = async (widgetSetupId, language) => {
      try {
        const response = await getWidgetTitleandInfo(widgetSetupId, language);
        if (response?.status != 200 || !response?.data) {
          throw new Error(
            "Failed to fetch widget title and info. Please try again later."
          );
        }
        widgetIdSettings = response?.data;
      } catch (error) {
        console.error("Error fetching widget settings:", error?.message);
      }
    }; 
    const fetchEventOrStandardTickets = async () => {
      try {
        const response = await getEventsOrStandardTickets(
          key,
          defaultLanguage,
          true,
          true
        );
     
        
          dispatch(updateEventsOrStandardTickets(response));
  
        
         // Assuming 'data' contains event or standard tickets data. Update the state with this data.
      } catch (error) {
        console.error("Error fetching events or standard tickets:", error);
      }
    };
    const fetchStdDatesForEvent = async () => {
      try {
        const response = await fetchStandardTicketsDates(key);
        dispatch(updateStdDates(response)); // Assuming 'data' contains standard dates data. Update the state with this data.
      } catch (error) {
        console.error("Error fetching standard dates for event:", error);
      }
    };
    const fetchEventDates = async (id) => {
      try {
        const response = await fetchEventTicketsDates(id);
        dispatch(updateEventDates(response)); // Assuming 'data' contains standard dates data. Update the state with this data.
      } catch (error) {
        console.error("Error fetching standard dates for event:", error);
      }
    };
  
    const fetchEventOrStdTicketTypes=async()=>{
      try {
        const response = await fetchEventOrStandardTicketsTypes( 
          key,
          defaultLanguage,
          reservType?.eventTicketId,
          reservType?.isStandardTicket ?selectedDate : selectedDate?.availableDate,
          reservType?.isStandardTicket);
        dispatch(updateEventOrStdTicketTypesData(response)); // Assuming 'data' contains event or standard ticket types data. Update the state with this data.
      } catch (error) {
        console.error("Error fetching event or standard ticket types:", error);
      }
    }
    const fetchExtraTicketProducts = async () => {
      try {
        const response = await getExtraProductDetails(
          SelectedEventOrStdResType?.idreservationtype,
          defaultLanguage
        );
        if (response?.status == 200) {
          dispatch(setExtraProductData(response?.data));
        }
      } catch (error) {
        console.log("error extra product", error?.message);
      }
    };
  
    const fetchWidgetSettingsDetails = async (lang) => {
      try {
        setWidgetLoading(true);
        const response = await FetchWidgetConfigDetails(key, widgetSetupId, lang,guestId);
        if (response?.status != 200 || !response?.data) {
          throw new Error(
            "Failed to fetch widget settings details. Please try again later."
          );
        }
        const result = response?.data?.basicLanguages?.reduce((acc, item) => {
          const tag = item.tag.replace(/{|}/g, "").replace(/\s+/g, "");
          const data = item.widgetTranslateLanguages[0]?.name;
          acc[tag] = data; // Assign data to the key acc[tag]
          return acc;
        }, {});
        dispatch(updateWidgetConfig(response?.data));
        dispatch(updateButtonText(response?.data?.fields?.reservationButtonText));
        dispatch(setLanguageWords(result));
        dispatch(updateCombinationLang({
          bookReservation: result?.bookReservation,
          selectCategory:result?.selectCategory
        }))
        setWidgetLoading(false);
      } catch (error) {
        console.error("Error fetching widget settings details:", error);
        setWidgetLoading(false);
      }
    };
  
    const fetchGuestDetailsByToken=async()=>{
      try {
        const response=await GetGuestDetailsByKey(widgetConfig?.token,key,guestId)
        if(!response){
          throw new Error("Failed to fetch guest details. Please try again later.")
        }
        dispatch(updateGuestInfo(response))
      } catch (error) {
        console.error("Error fetching guest details by token:", error);  
      }
    }

    useEffect(()=>{
      if(widgetConfig?.token){
        fetchGuestDetailsByToken()
      }
    },[widgetConfig])
    
    useEffect(() => {
      if(Object.keys(SelectedEventOrStdResType)?.length > 0 && SelectedEventOrStdResType?.idreservationtype){
        fetchExtraTicketProducts();
      }
    }, [SelectedEventOrStdResType]);
  
    const handleClose = () => {
      setOpenWidget(false);
    };
    useEffect(() => {
      if (key && defaultLanguage) fetchEventOrStandardTickets();
    }, [defaultLanguage]);
    useEffect(() => {
      if (!languageLoaded && !isBackToHoreca) {
        fetchLanguageDetails();
      }
    }, [languageLoaded, isBackToHoreca]);
    useEffect(() => {
      if (defaultLanguage && defaultLanguage.trim() !== "" && !isBackToHoreca) {
        fetchWidgetSettings(defaultLanguage);
      }
    }, [defaultLanguage, isBackToHoreca]);
    useEffect(() => {
      if (defaultLanguage && defaultLanguage.trim() !== "") {
        // Checks if defaultLanguage is a non-empty string
        fetchWidgetSettingsDetails(defaultLanguage);
      }
    }, [defaultLanguage]);
    useEffect(() => {
      if (defaultLanguage?.trim() != "" && !isBackToHoreca)
        fetchWidgetTitleandInfo(widgetSetupId, defaultLanguage);
    }, [defaultLanguage, isBackToHoreca]);
    useEffect(() => {
      if (Object.keys(reservType)?.length > 0) {
        if (reservType?.isStandardTicket) {
          fetchStdDatesForEvent();
        } else {
          fetchEventDates(reservType?.eventTicketId);
        }
      }
    }, [reservType]);
    useEffect(()=>{
      if(Object.keys(reservType)?.length > 0 && selectedDate) fetchEventOrStdTicketTypes()
    },[selectedDate])

    const fetchCombinations = async () => {
      dispatch(setCombinationList([]));
      const payload = {
        key: key,
        idreservationtype: parseInt(SelectedEventOrStdResType?.idreservationtype),
        ArrivalDate: reservType?.isStandardTicket ? selectedDate : selectedDate?.availableDate,
        ArrivalTime: '09:00',
        DepatureTime:'12:00',
        Field1: parseInt(adult),
        Field2: parseInt(child),
        Field3: parseInt(kid),
        Field4: parseInt(toddler),
        Field5: parseInt(baby),
        LanguageCode: defaultLanguage,
        NoOfGuest: parseInt(totalCount),
      };
      try {
        const response = await getCombinationList(payload);
        dispatch(setCombinationList(response));
      } catch (error) {
        console.error(error);
      }
    };
    useEffect(() => {
      if(Object.keys(SelectedEventOrStdResType)?.length > 0 && SelectedEventOrStdResType?.idreservationtype){
        fetchCombinations();
      }
    }, [SelectedEventOrStdResType]);
  
    useEffect(()=>{
      if(EventDates?.length == 1){
        dispatch(updateSelectedDate(EventDates[0]));
      }
    },[EventDates])
  
    const send = (
      frameHeight,
      frameWidth,
      top,
      right,
      bottom,
      left,
      floating,
      redirectUrl
    ) => {
      window.parent.postMessage(
        {
          reservationIframeHeight: frameHeight,
          reservationIframeWidth: frameWidth,
          reservationIframePositionTop: top,
          reservationIframePositionRight: right,
          reservationIframePositionBottom: bottom,
          reservationIframePositionLeft: left,
          reservationIframePositionFloating: floating,
          redirectUrl: redirectUrl,
        },
        "*"
      );
    };
    // get the height of the widget
    const getHeight = () => {
      setTimeout(() => {
        let rootHeight = document.getElementsByClassName("MuiBox-root")[1];
        let popupHeight = document.getElementsByClassName("MuiPaper-root")[0];
        let frameHeight = 200;
        if (rootHeight) {
          if (rootHeight.clientHeight > frameHeight) {
            if (rootHeight.clientWidth < 700) {
              frameHeight = rootHeight.clientHeight + 100;
            } else {
              frameHeight = rootHeight.clientHeight + 20;
            }
          }
          if (popupHeight) {
            if (frameHeight < 520) {
              frameHeight = 520;
            }
          }
        }
        send(
          frameHeight + "px",
          "100%",
          "",
          "0px",
          "0px",
          "",
          widgetConfig?.settings?.floatButtonActive
        );
      }, 100);
    };
    // get the height of the MuiBox-root after loading the full page
    useEffect(() => {
      if (!widgetConfig?.settings?.floatButtonActive || floating === "relative") {
        getHeight();
      }
    },[]);

  return {
    totalCount,
    EventDates,
    selectedDate,
    reservType,
    adult,
    child,
    kid,
    baby,
    toddler,
    isBackToHoreca,
    defaultLanguage,
    isOpenWidget,
    SelectedEventOrStdResType,
    key,
    widgetConfig,
    languageLoaded,
    guestId,
    resType,
    location,
    navigate,
    dispatch,
    openWidget, 
    setOpenWidget,
    getWidgetPositionStyle,
    send,
    widgetLoading,
    setWidgetLoading,
    theme,
    handleClose,
    buttonText
  }
}

export default useTicketingWidget
